<template>
    <div class="flex -wrap articles_columns">
        <Article v-for="(item, index) in content" :key="'article_' + index" :title="inlinedata(item, 'naam', currentlang)"
            :text="inlinedata(item, 'tekst', currentlang)" :img="item.afbeelding1"></Article>
    </div>
</template>

<script>
import Article from '@/components/Article.vue';

export default {
    name: 'Items',
    components: { Article },
    props: {
        content: [String, Array],
    },
    computed: {
        currentlang() {
            return this.$store.getters['Language/current'];
        },
    },
};
</script>
